/** Author - Karthika
 * Created on 16/01/2023
 */


/********* RoleId Constatn--->Please Refer usersRoles Table to map the ID******* USER TYPE ID*/
export const ITC_ADMIN_ROLE_ID = 1;
export const CLIENT_ADMIN = 2;
export const HUB_OPERATOR_ROLE_ID = 3;
export const HUB_MANAGER_ROLE_ID = 4;
export const MERCHANT_ROLE_ID = 5;
export const RIDER_ROLE_ID = 6;
export const SECURITY_ROLE_ID = 7;
export const CUSTOMER_ROLE_ID = 8;
export const DRIVER_EMPLOYER_ROLE_ID = 9;



export const ACCOUNT_LOIGN_RETRY_COUNT = 3;


// vehicle type
export const BICYCLE = 1;
export const MOTORCYCLE = 2;
export const CAR = 3;
export const VAN = 4;
export const LIGHT_TRUCK = 5;
export const HEAVY_TRUCK = 6;



export const ASSIGNED = "#8DE7AA";
export const DELIVERED_FREED = "#357FFF";
export const RETURNED_FREED = "#32CA73";
export const DELIVERED_BUSY = "#FF6969";
export const ON_BREAK = "#FFCA63";
export const UNAVAILABLE = "#0D1E1C";

export const GREEN_COLOR = "#1EAA5D";
export const BLACK_COLOR = "#0D1E1C"


//rider status constants

export const ALL_RIDER = 0;
export const RIDER_PICKED_UP = 1;
export const RIDER_DEPARTED = 2;
export const RIDER_FREED = 3;
export const RIDER_BUSY = 4;
export const RIDER_RETURNED = 5;
export const RIDER_ASSIGNED = 6;
export const RIDER_UNDELIVERED = 7;
export const RIDER_NEAR_STORE = 8; // not being used
export const RIDER_RETURN_FREED = 9;
export const RIDER_UNAVAILABLE = 10;
export const RIDER_ON_BREAK = 11;


export const ITCADMIN_ACCOUNT_NO = 5585;


/** ==========================================*/

// export const ITC_ADMIN_USER_TYPE=1;
// export const HUB_ADMIN_USER_TYPE=2;

export const GRL_URL = "https://www.grl.ae/addressapi/wosapi.php?access_token=yyw3Nh0aBWJ3bfPX3ohCBXHMaYmHm94x";

/** Order Status Operation Type */
export const OPERATION_TYPE_FOR_DROP_OFF_ASSIGNED = 1;
export const OPERATION_TYPE_FOR_UNDELIVERED = 5;
export const OPERATION_TYPE_FOR_PICKUP_READY = 19;
export const OPERATION_TYPE_FOR_PICKUP_ASSIGNED = 18;
export const OPERATION_TYPE_FOR_PICK_UP_ORDER_CREATION = 6;
export const OPERATION_TYPE_FOR_DROP_OFF_ORDER_CREATION = 6;
export const OPERATION_TYPE_FOR_PGI = 12; //post goods recived
export const OPERATION_TYPE_FOR_GOODS_RECEIVED = 13; //goods recived
export const OPERATION_TYPE_FOR_GOODS_RECEIVED_RS = 15; //goods recived - Rescheduled
export const OPERATION_TYPE_FOR_CANCELLED = 4;
export const OPERATION_TYPE_FOR_PICKUP_WITHDRWN = 21;
export const OPERATION_TYPE_FOR_RE_ASSIGNMENT = 26;
export const OPERATION_TYPE_FOR_RE_RESCHEDULE = 25;
export const OPERATION_TYPE_FOR_PARTIAL_DELIVERY = 9;



export const OPERATION_TYPE_FOR_BULK_ORDER_ASSIGNMENT = 50;
export const OPERATION_TYPE_FOR_ORDER_RECALL = 51;


export const ORDER_CANCELLATION_REQUEST_STATUS = 1;
export const ORDER_CANCELLATION_APPROVED_STATUS = 2;

/*************** Address Type */

export const ADDRESS_TYPE_OWN_HUB = 1;
export const ADDRESS_TYPE_HUB_CUSTOMER = 2;
export const ADDRESS_TYPE_MERCHANT = 3;
export const ADDRESS_TYPE_ANOTHER_HUB = 4; //this will use if merchant is punching order
export const ADDRESS_TYPE_MERCHANT_CUSTOMER = 5;

export const ORDER_TYPE_DROP_OFF = 1;
export const ORDER_TYPE_PICK_UP = 2;
export const ORDER_TYPE_PICK_N_DROP = 3;



export const RIDER_AVAILABILITY_STATUS_ON_DUTY = 1;
export const RIDER_AVAILABILITY_STATUS_OFF_DUTY = 2;
export const RIDER_AVAILABILITY_STATUS_ON_VACATION = 5;

export const RIDER_STATUS_DELIVERED_FREED = 3;
export const RIDER_DUTY_STATUS_RETURNED_FREED = 9
export const RIDER_DUTY_STATUS_RETURNED = 5;


export const API_KEY = "AIzaSyBGRy49yZEST7YA30FoiSJmE2o_B5_czfk"; //google


/************  User Login Identifier */

export const LOGIN_ITC_ADMIN_IDENTIFIER = 1;
export const LOGIN_HUB_USER_IDENTIFIER = 2; /** Hub Manager, hub operator and Security */
export const LOGIN_MERCHANT_IDENTIFIER = 3;


/******PND Messages**** */

export const ERROR_MESSAGES = {
    tryCatchError: "An unexpected error occurred. Please try again later.",
    successMessage: "Details saved successfully."

};

/*** Secuirty Approval Status */


export const APPROVAL_STATUS_APPROVED = 1;
export const APPROVAL_STATUS_DECLINED = 2;

export const OPERATIONAL_STATUS_SECURITY_ORDER_LIST=1;
export const OPERATIONAL_STATUS_SECURITY_HISTORY_LIST=2;

export const PAGE_TIMEOUT = 2000;
export const DASHBOARD_REFRESH_INTERVAL = 240000; // 4 minutes in milliseconds
//export const PND_LIVE_LOCATION_REFRESH_INTERVAL = 60000;// every 2 min 120000
export const PND_LIVE_LOCATION_REFRESH_INTERVAL = 10000; // Every 10 seconds

/*** Notification Type */

export const NOTIFICATION_TYPE_CHAT_MESSAGE= 1;
export const NOTIFICATION_TYPE_SECURITY_APPROVAL = 15;
export const NOTIFICATION_TYPE_NEW_ORDER= 5;

/** SCS Order Type */

export const SCS_ORDER_TYPE_YALLA = 'ZECC';
export const SCS_ORDER_TYPE_STANDARAD = 'ZEOR';